"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var inertia_react_1 = require("@inertiajs/inertia-react");
function useTypedPage() {
    return (0, inertia_react_1.usePage)();
}
exports.default = useTypedPage;
